import { useEffect } from 'react';
import useAppState from '../../../../common/state/appState';
import HomeBaseHero from './HomeBaseHero';
import { useMuiMediaQuery } from '../../../../utilities/hooks';
import usePageStateTracking from '../../utilities/pageStateStatusHelpers';

function HomeBase() {
    const recentlyViewedVehicles = useAppState((state) => state.recentlyViewedVehicles);
    const getFbsDataForStockNumbers = useAppState((state) => state.getFbsDataForStockNumbers);

    const homeOptimizationTestGroup = useAppState((state) => state.homebaseOptimizationGroup);
    const { isMobile } = useMuiMediaQuery();
    const showOptTestContent = homeOptimizationTestGroup === 'test' && !isMobile;

    usePageStateTracking();

    useEffect(() => {
        if (recentlyViewedVehicles?.length > 0) {
            getFbsDataForStockNumbers(recentlyViewedVehicles.map((v) => v.stockNumber));
        }
    }, [recentlyViewedVehicles, getFbsDataForStockNumbers]);

    return <HomeBaseHero fullStoryPageId="HP" showOptTestContent={showOptTestContent} />;
}

export default HomeBase;
